<template>
	<div class="header-container" :class="{'no-breadcrumb' : breadcrumb === null}">
		<div class="main-content container">
			<div class="logo">
				<img src="@/assets/img/upmood_logo.svg" alt="upmood">
			</div>

			<div class="admin-options">
				<div
					class="admin-dropdown"
					@click.self="toggleAdminOptions()"
					v-on-clickaway="hideAdminOptions"
				>
					<div class="img-container" />

					<span class="admin-label">
						{{ `${user.last_name}, ${user.first_name}` }}
					</span>

					<Flyout
						class="flyout-container"
						width="calc(100% - 53px)"
						right="-15px"
						top="125%"
						:active="isAdminOptionsActive"
					>
						<div
							slot="flyout-item"
							class="flyout-item"
							@click="signOut()"
						>
							{{ 'Log out' }}
						</div>
					</Flyout>

					<div class="chervon-down" />

				</div>
			</div>
		</div>

		<!-- <footer  v-if="breadcrumb">
			<div class="breadcrumb">
				<img
					src="@/assets/img/icon/home.png"
					class="icon"
					@click="$router.push(breadcrumb.homeLink)"
				>

				<div
					class="path-name parent"
					v-for="(parent,index) in breadcrumb.parents"
					:key="index"
					@click="backToParentRoute(parent.path,parent.props)"
				>
					{{ parent.name }}
				</div>

				<div class="path-name">
					{{ breadcrumb.name }}
				</div>
			</div>
		</footer> -->
	</div>
</template>
<script>
import { mapFields } from 'vuex-map-fields'

import Flyout from '@/components/utils/Flyout'
export default {
	data () {
		return {
			isNotifActive: false,
			isAdminOptionsActive: false
		}
	},

	components: {
		Flyout
	},

	computed: {
		...mapFields('auth', [
            'user',
		]),
		
		breadcrumb () {
			return this.$route.meta.breadcrumb || null
		},

		headerName () {
			return this.parseBreadCrumb(this.$route.meta.header) || 'Upmood'
		}
	},

	methods: {
		toggleNotification () {
			this.isNotifActive = !this.isNotifActive
		},

		toggleAdminOptions () {
			this.isAdminOptionsActive = !this.isAdminOptionsActive
		},

		hideNotification () {
			this.isNotifActive = false
		},

		hideAdminOptions () {
			this.isAdminOptionsActive = false
		},

		signOut () {
			this.$store.dispatch('auth/signOut')
		},

		backToParentRoute (path, props) {
			let p = props.map(prop => '/' + this.$route.params[prop])
			this.$router.push(path + p)
		},

		parseBreadCrumb (text) {
			return text ? text.toLowerCase().replace(/ /g, '_') : ''
		}
	}
}
</script>
<style lang="scss" scoped>
	.header-container {
		width: 100%;
		background-color: #FFFFFF;

		&.no-breadcrumb {
			box-shadow: 0 1px 3px #00000029;
		}

		.main-content {
			padding: 15px 20px;
			display: flex;
			align-items: center;

			.logo {
				flex: 1 1 auto;
				display: flex;
				align-items: center;

				img {
					width: 100px;
				}
			}

			.admin-options {
				height: 100%;
				display: flex;
				align-items: center;

				.notification {
					width: 20px;
					height: 22px;
					cursor: pointer;
					background-image: url('../../assets/img/icon/Notification.png');
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;
					position: relative;
				}

				.admin-dropdown {
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					color: #43425D;
					font-size: 14px;
					border-left: 1px solid #A4AFB7;
					margin-left: 15px;
					position: relative;
					min-width: 180px;

					.admin-label, .chervon-down {
						pointer-events: none;
					}

					.chervon-down {
						position: relative;
						&::after {
							content: '';
							top: -5px;
							left: 0;
							position: absolute;
							margin-left: 10px;
							width: 5px;
							height: 5px;
							border-right: 2px solid #A4AFB7;
							border-bottom: 2px solid #A4AFB7;
							border-top: 1px solid transparent;
							border-left: 1px solid transparent;
							transform: rotate(45deg);
						}
					}

					.img-container {
						border: 1px solid #848484;
						margin-right: 20px;
						width: 35px;
						height: 35px;
						border-radius: 50%;
						overflow: hidden;
						background-image: url('../../assets/img/avatar-default.png');
						background-size: cover;
						background-repeat: no-repeat;
						background-position: center;
					}
				}
			}
		}

		// footer {
		// 	background-color: #F5F6FA;
		// 	padding: 5px 30px;
		// 	box-shadow: 0 1px 3px #00000029;

		// 	.breadcrumb {
		// 		display: flex;
		// 		align-items: center;

		// 		.icon {
		// 			width: 20px;
		// 			height: 20px;
		// 			cursor: pointer;
		// 		}

		// 		.path-name {
		// 			color: #979CAC;
		// 			font-size: 18px;
		// 			display: flex;
		// 			align-items: center;
		// 			margin-left: 5px;

		// 			&::before {
		// 				content: '';
		// 				border-top: 3px solid #BCBCCB;
		// 				border-right: 3px solid #BCBCCB;
		// 				height: 6px;
		// 				width: 6px;
		// 				margin-right: 8px;
		// 				transform: rotateZ(45deg);
		// 			}

		// 			&.parent {
		// 				cursor: pointer;
		// 			}
		// 		}
		// 	}
		// }
	}
</style>
